import { Advance } from "../domain/advance";
import { getAdvancesByDayService } from "../infrastructure/services/getAdvancesByDayService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const getAdvancesByDay = {
    async execute(paymentDate: string): Promise<Advance[]> {
        return await getAdvancesByDayService.execute(await tokenValidation.execute(), paymentDate);
    },
};
